import React from 'react'

export const DrawerContext = React.createContext({
  open: true,
  toggle: () => {}
})
